import React from "react";
import { css } from "glamor";
import { AiFillCaretLeft } from "react-icons/ai";
import { Link, colors, spacing } from "../library";
import StudyGoalContainer from "../studyGoal/StudyGoalContainer";
import CourseDailyStudyPlanContainer from "../courseContents/CourseDailyStudyPlanContainer";

const backClass = css({
  color: colors.primaryShadow,
  display: "flex",
  alignItems: "center",
  gap: spacing.xxs,
  fontSize: 16,
  marginBottom: spacing.m,
  ":hover": {
    color: colors.primary,
    cursor: "pointer",
  },
});

export default function CourseStudyPlan() {
  return (
    <div>
      <Link to="/" className={backClass} component="div">
        <AiFillCaretLeft size={18} /> VOLTAR
      </Link>
      <StudyGoalContainer />
      <div style={{ marginTop: spacing.l }}>
        <CourseDailyStudyPlanContainer />
      </div>
    </div>
  );
}
